module.exports = __webpack_public_path__ + "static/img/内江六院.7f0ca49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/内江六院.jpg
// module id = Zp/D
// module chunks = 54